import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import UserSearchHorizontal from './UserSearch/UserSearchHorizontal';
import UsersTable from './UsersTable';
import { getAdminUserData, getAdminUserList } from '../../../actions/adminActions';

class Users extends Component {
  static propTypes = {
    adminUsers: PropTypes.instanceOf(Object),
    adminAccounts: PropTypes.instanceOf(Object),
    userSearchQuery: PropTypes.instanceOf(Object),
    getAdminUserList: PropTypes.func,
    isUserSearching: PropTypes.bool,
  }
  static defaultProps = {
    adminUsers: {},
    adminAccounts: {},
    userSearchQuery: {},
    isUserSearching: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      users: [],
      hasMorePages: true,
      searchTerm: {},
      pageStart: 1,
      sortOrder: 'asc',
    };
  }

  UNSAFE_componentWillMount() {
    const { adminUsers, userSearchQuery } = this.props;
    this.updateSearchQuery(adminUsers, userSearchQuery);
  }

  UNSAFE_componentWillReceiveProps({ adminUsers, userSearchQuery }) {
    this.updateSearchQuery(adminUsers, userSearchQuery);
  }

  updateSearchQuery = (adminUsers, userSearchQuery) => {
    if (!_.isEqual(adminUsers.data, this.state.users)) {
      this.setState({
        users: adminUsers.data,
        hasMorePages: adminUsers.hasMorePages,
        pageStart: 1,
      });
    }
    if (!_.isEmpty(userSearchQuery)) {
      const queryObj = _.cloneDeep(userSearchQuery);
      if (!_.isEmpty(queryObj.accountIds)) {
        queryObj.accountIds = queryObj.accountIds;
      }

      if (!_.isEmpty(queryObj.statusIds)) {
        queryObj.statusIds = queryObj.statusIds;
      }
      const updatedSearchTerm = { ...this.state.searchTerm, ...queryObj };
      this.setState({ searchTerm: updatedSearchTerm });
    }
  }

  loadItems = page => {
    const { searchTerm } = this.state;
    const sq = _.cloneDeep(searchTerm);
    sq.pageNo = page.toString();
    getAdminUserData(sq)
    .then(response => {
      const moreUsers = _.cloneDeep(this.state.users);
      response.data.map(item => {
        moreUsers.push(item);
        return null;
      });
      this.setState({
        hasMorePages: response.hasMorePages,
        users: moreUsers,
      });
    });
  }

  onSort = (sortBy, sortOrder) => {
    const { searchTerm } = this.state;
    const sq = _.cloneDeep(searchTerm);
    sq.sortBy = sortBy;
    sq.sortOrder = sortOrder;
    sq.pageNo = '1';
    this.setState({ sortOrder, searchTerm: sq, pageStart: 1 }, () => {
      this.props.getAdminUserList(this.state.searchTerm);
    });
  }

  render() {
    const { adminAccounts, isUserSearching } = this.props;
    const { users, pageStart, hasMorePages, sortOrder } = this.state;

    return (
      <div>
        {adminAccounts.data && <UserSearchHorizontal accounts={adminAccounts} />}
        {_.isEmpty(users) && isUserSearching && (
          <div className="no-result">No result found. </div>
        )}
        {!_.isEmpty(users) && (
          <div>
            <UsersTable
              users={users}
              loadMore={this.loadItems}
              hasMore={hasMorePages}
              pageStart={pageStart}
              sortOrder={sortOrder}
              onSort={this.onSort}
            />
            <div className="status-labels">
              <strong>Status*</strong><br />
              Invited - Has never logged in.<br />
              Active - Logged in at least 1 time; 1 or more account(s) selected.<br />
              Inactive - Logged in at least 1 time; no accounts selected.<br />
              Deleted - Login prevented.
            </div>
          </div>
        )}

      </div>
    );
  }
}

const mapStateToProps = ({ admin }) => {
  return {
    adminUsers: admin.adminUsers,
    isUserSearching: admin.isUserSearching,
    adminAccounts: admin.adminAccounts,
    userSearchQuery: admin.userSearchQuery,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminUserList: bindActionCreators(getAdminUserList, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);

